import firebase from 'firebase'

// Dev - Dino firebase copy
const firebaseConfig = {
    apiKey: "AIzaSyDyidWDr11L2_1K2j2upCBzxkR15DJoMx4",
    authDomain: "testing-serverless-28c09.firebaseapp.com",
    projectId: "testing-serverless-28c09",
    storageBucket: "testing-serverless-28c09.appspot.com",
    messagingSenderId: "319594767693",
    appId: "1:319594767693:web:3373c62aaeb403139f8304"
}

// Prod
// const firebaseConfig = {
//     apiKey: "AIzaSyC-guZDoDpsWDNA52uIbJn6T5KjdDxteSU",
//     authDomain: "qcast-81705.firebaseapp.com",
//     databaseURL: "https://qcast-81705.firebaseio.com",
//     projectId: "qcast-81705",
//     storageBucket: "qcast-81705.appspot.com",
//     messagingSenderId: "992093271815",
//     appId: "1:992093271815:web:296d84bb0028865635f7a2",
//     measurementId: "G-2D14Z6ZKV4"
// }

const firebaseApp = firebase.initializeApp(firebaseConfig)
const db = firebaseApp.firestore()
const auth = firebaseApp.auth()
const storage = firebaseApp.storage()
const functions = firebaseApp.functions()

export {firebaseApp, auth, db, storage, functions}
// export default db